import React from 'react';
import { ApptRequestIvStatusDialogProvider } from './provider';

export interface ApptRequestIvStatusDialogHocProps {
  opened: boolean;
  appointmentRequestId: number;
  locationId: number;
  onClose: () => void;
}

export const withApptRequestIvStatusDialogProvider = <P extends ApptRequestIvStatusDialogHocProps>(
  Component: React.ComponentType<P>
) => {
  const ComponentWidthProvider: React.FC<P> = (props) => {
    const { opened, onClose, appointmentRequestId, locationId /*, providerId*/ } = props;

    return (
      <>
        {opened && (
          <ApptRequestIvStatusDialogProvider
            opened={opened}
            onClose={onClose}
            appointmentRequestId={appointmentRequestId}
            locationId={locationId}
          >
            <Component {...props} />
          </ApptRequestIvStatusDialogProvider>
        )}
      </>
    );
  };

  return ComponentWidthProvider;
};
